export default function ({ $auth, redirect }) {
  const isAdmin = !!$auth?.user?.roles?.some((role) =>
    ['ADMIN', 'MODERATOR'].includes(role)
  )
  if (!isAdmin) {
    return redirect('/login')
  }
}
